const styles = {
  menu: {
    height: '60px',
    border: '0px',
    margin: '0px 0px',
  },

  menuItem: {
    fontFamily: 'Helvetica',
    fontSize: '11px',
    fontWeight: 'bold',
    lineHeight: 1.36,
    color: '#015d03',
    paddingLeft: '5px',
    paddingRight: '5px',
    // marginLeft: '5px',
    // marginRight: '5px',
  },

  huddleLogo: {
    height: '30px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '15px',
    marginBottom: '10px',
  },

  /* let huddleLogoContainer : {
      height: "60px",
      width: "310px",
      borderBottom: "5px solid #dd9933"
    },*/

  usaTodayLogo: {
    height: '30px',
    marginTop: '15px',
    marginRight: '21px',
  },

  icon: {
    marginLeft: '10px',
    marginRight: '20px',
  },

  separator: {
    width: '2px',
    height: '24px',
    border: 'solid 1px #cccccc',
    margin: '18px 5px 0px 5px',
  },

  /* MyHuddle Dropdown menu*/
  myHuddleMenu: {
    left: 0,
    width: '174px',
    borderRadius: '4px',
    border: '0px',
    // margin: '0px 0px',
    backgroundColor: '#ccdfcd',
    boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.1), 0 1px 0 0 rgba(0, 0, 0, 0.08)',
    paddingLeft: '16px',
    paddingRight: '16px',
  },

  myhuddleButton: {
    borderRadius: '4px',
    backgroundColor: '#ccdfcd',
    border: 'solid 1px #ffffff',
    padding: '5px 10px 5px 10px',
    fontFamily: 'Helvetica',
    fontSize: '11px',
    fontWeight: 'bold',
    color: '#015d03',
    // border: 'solid 1px #015d03',
  },

  myhuddleButtonText: {
    fontFamily: "'Helvetica Neue', Helvetica, Arial",
    fontSize: '11px',
    fontWeight: 'bold',
    lineHeight: 1.36,
    color: '#015d03',
  },

  myHuddleLink: {
    color: 'inherit',
  },

  welcomeText: {
    fontFamily: "'Helvetica Neue', Helvetica, Arial",
    fontSize: '11px',
    fontWeight: 'oblique',
    lineHeight: 1.36,
    color: '#999999',
  },

  angleIcon: {
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: 0.84,
    margin: '0px',
    verticalAlign: 'middle',
    padding: '0px',
  },

};

export default styles;



// WEBPACK FOOTER //
// ./src/app/components/Header/DesktopHeader/DesktopHeader.styles.js